import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom";
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import Moment from "react-moment";
import Paper from "@material-ui/core/Paper";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Icon from '@material-ui/core/Icon';
//import { configure, setAddon } from '@storybook/react';
import { BreadcrumbPage } from "../../shared";
import CheckIcon from '@material-ui/icons/Check';
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import { InputLabel, TextareaAutosize } from '@material-ui/core';
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';
import { getCookie } from "../../services/Cookies";
import { postRequest, getRequest, putRequest } from "../../services/ApiServices";
//import {SupportFormat} from "./SupportFormat";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import supportuser from "./TicketForm";
import grey from "@material-ui/core/colors/grey";
import clsx from "clsx";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import {
  FormHelperText,
  Input,
  InputBase,
} from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  alignItemsStretch: {
    alignItems: "stretch",
  },
  mainBox: {
    width: "95%",
    height: "650px",
    backgroundColor: '#fff',
    marginRight: '2rem',
    marginLeft: '2rem',
    boxShadow: "0px 4px 5px -3px rgba(1,1,1,0.75)",
    overflow:"auto",
    marginTop:""
  },
  form: {
    textAlign: "center",
    width: '60vw',
    height: '60vh',
    position: 'absolute',
    top: "42%",
    left: "50%",
    transform: 'translate(-50%,-50%)',
    marginTop: "5rem !important"


  },
  item: {
    width: "50px",
  },
  borderRight: {
    borderRight: "1px solid " + grey[400],
  },
  MuiButtonBaseRoot: {
    borderRadius: 4,
    padding: 0,
    paddingBottom: "2px",
    color: grey[400],
  },
  MuiSvgIconRoot: {
    color: "#ff4717",
    border: "2px solid " + grey[400],
    fontSize: "1.3rem",
    borderRadius: 3,
  },
  anchorTag: {
    textDecoration: "none",
    cursor: "pointer",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
  formControl: {
    // margin: theme.spacing(1),
    minWidth: "338px",
    "& select": {
      padding: "6px"
    }
  },
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#000",
    color: "#fff",
  },
  body: {},
}))(TableCell);

const StyledSubTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: grey[400],
  },
  body: {},
}))(TableCell);

function Support(props) {
  const BreadcrumbList = [{ name: "Support", url: "" }];
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [registeredUsers, setRegisteredUsers] = useState([]);
  const [formObj, setFormObj] = useState(supportuser);




  const getTicketData = async (ticketId) => {

    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `SupportTicket/provideTicket/` + ticketId;

    dispatch({ type: LOADING, payload: true });
    await getRequest(url)
      .then((res) => {
        dispatch({ type: LOADING, payload: false });
        //console.log(res);
        setFormObj({ ...res.data });
        setRegisteredUsers(res.data);
        //ToastSuccess('Submitted successfully')
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        //console.log(error);

      });
  }
  useEffect(() => {
    getTicketData(props.match.params.ticketId);
  }, []);
  const onSavedetails = () => {


    ;
    updateSaveItems({
      NewStatus: formObj.status,
      Notes: formObj.notes,
      TicketId: formObj.ticketId


    });

  }
  const updateSaveItems = async (data) => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `SupportTicket/UpdateTicketStatus`;

    dispatch({ type: LOADING, payload: true });
    await postRequest(url, data)
      .then((res) => {
        dispatch({ type: LOADING, payload: false });
        //console.log(res);
        setFormObj({ ...formObj });
        ToastSuccess('Saved successfully')
        history.push("/dashboard/support-tickets");
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        //console.log(error);

      });
    //console.log(formObj);


  }
  const onChangeStatus = (event) => {
    formObj.status = event.target.value;
    setFormObj({ ...formObj });
  };
  const onTextChange = (event) => {
    formObj.notes = event.target.value;
    setFormObj({ ...formObj });
    ////console.log("notesTextbox",event.target.value);
  };
  //console.log(formObj, "on page load");

function HistoryRow(props) {
  ;
  const { row } = props;

  return (
    <React.Fragment>
      <TableRow style={{ overflow: "scroll" }}
      >
        <TableCell>{row.newstatus}</TableCell>
        <TableCell>{row.createdBy}</TableCell>
        <TableCell>{row.date ? <Moment format="DD/MM/YYYY">{row.date}</Moment> : ""}</TableCell>
        <TableCell>{row.notes}</TableCell>
      </TableRow>
      {/*  <Confirmation  open={openAlert} onClose={handleClose} onHandleSubmit ={onAlertSubmit} /> */}
    </React.Fragment>
  );
}

HistoryRow.propTypes = {
  row: PropTypes.shape({
    ticketId: PropTypes.string.isRequired,
  }).isRequired,
}

  return (

    <div >

      
      <div className={classes.mainBox} >
      <Box pb={3} pt={0} display="dlock">
        <BreadcrumbPage rows={BreadcrumbList} />
      </Box>
        <Form className={classes.form} > {/*  {registeredUsers.raisedby===formObj.UserEmail ? registeredUsers.map((user)=>{
       return  <h5>{user.ticketId}{user.raisedby} </h5>
    }):""} */}
          <Form.Group as={Row} controlId="formHorizontalEmail" className="justify-content-md-center">
            <Form.Label column sm={2}>
              Ticket ID
    </Form.Label>
            <Col sm={4}>
              <Form.Control readOnly type="email" defaultValue={formObj.ticketId} name="TicketId" />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="formHorizontalEmail" className="justify-content-md-center">
            <Form.Label column sm={2}>
              Raised By
    </Form.Label>
            <Col sm={4}>
              <Form.Control readOnly type="email" defaultValue={formObj.raisedby} name="UserEmail" />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="formHorizontalPassword" className="justify-content-md-center">
            <Form.Label column sm={2}>
              Attachments
    </Form.Label>
            <Col sm={4}>
              <Form.Control readOnly type="email" defaultValue={formObj.attachmentId} name="UserEmail" />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="formHorizontalPassword" className="justify-content-md-center">
            <Form.Label column sm={2}>
              Status
    </Form.Label>
            <Col sm={4} className={classes.formControl + " cust-select-1"}>

              <select name="status" defaultValue={formObj.status} value={formObj.status} style={{width:"100%"}}
                onChange={onChangeStatus} >
                <option value="Open"  >Open</option>
                <option value="Assigned - VPS">Assigned - VPS</option>
                <option value="Assigned - Natobotics">Assigned - Natobotics</option>
                <option value="In Progress">In Progress</option>
                <option value="Resolved">Resolved</option>
                <option value="Cannot Fix">Cannot Fix</option>
                <option value="CR - Open">CR - Open</option>
                <option value="CR - Waiting for Approval">CR - Waiting for Approval</option>
                <option value="CR - Assigned - VPS">CR - Assigned - VPS</option>
                <option value="CR - Assigned - Natobotics">CR - Assigned - Natobotics</option>
                <option value="CR - In Progress">CR - In Progress</option>
                <option value="CR - Resolved">CR - Resolved</option>
              </select>
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="formHorizontalPassword" className="justify-content-md-center">
            <Form.Label column sm={2} >
              Issue Description
            </Form.Label>
            <Col sm={4}>
            <TextareaAutosize
              rowsMin={8}
              rowMax={8}
              name="Notes" defaultValue={formObj.description}  style={{width:"100%",overflow:"auto",maxHeight:"150px"}}
              />
            
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="formHorizontalPassword" className="justify-content-md-center">
            <Form.Label column sm={2} >
              Notes
            </Form.Label>
            <Col sm={4}>
            <TextareaAutosize
              rowsMin={8}
              rowMax={8}
              name="Notes" defaultValue={formObj.notes} onChange={onTextChange} style={{width:"100%",overflow:"auto",maxHeight:"150px"}}
              />
            </Col>
          </Form.Group>







          <Form.Group as={Row} className="justify-content-md-center">
            <Col sm={{ span: 4, offset: 2 }}>
              <button type="button" className={classes.btnStyle2} onClick={onSavedetails} >Save</button>  
      
            </Col>

          </Form.Group>
        </Form>
      </div >
      <div className={classes.mainBox} style={{marginTop:"20px"}}>
        <Box display="block" mb={3} my={3} component="div">
          <TableContainer component={Paper} className={classes.boxShadow_0}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <StyledTableCell className="bl-bg" />
                  <StyledTableCell className="bl-bg">
                    {/* Vessel Name (IMO) */}
                  </StyledTableCell>
                  <StyledTableCell className="bl-bg">
                    {/* Vessel Name (IMO) */}
                  </StyledTableCell>
                  <StyledTableCell className="bl-bg">
                    {/* Vessel Name (IMO) */}
                  </StyledTableCell>
                  <StyledTableCell className="bl-bg">
                    {/* Vessel Name (IMO) */}
                  </StyledTableCell>
                  <StyledTableCell className="bl-bg">
                    {/* Vessel Name (IMO) */}
                  </StyledTableCell>
                  <StyledTableCell className="bl-bg" >History</StyledTableCell>
                  <StyledTableCell className="bl-bg">
                    {/* Vessel Name (IMO) */}
                  </StyledTableCell>
                  <StyledTableCell className="bl-bg">
                    {/* Dispatch Port */}
                  </StyledTableCell>
                  <StyledTableCell className="bl-bg">
                    {/* Reported Date */}
                  </StyledTableCell>
                  <StyledTableCell className="bl-bg" padding="checkbox">
                    {/* <MyCheckbox
                        checked={selectedRowCount}
                        onChange={(event) => {
                          selectAllCheckbox(event);
                        }}
                      /> */}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
          <Table size="large" aria-label="purchases">
            <TableHead>
              <TableRow>


                <StyledSubTableCell>Status</StyledSubTableCell>
                <StyledSubTableCell>Changed By</StyledSubTableCell>
                <StyledSubTableCell>Changed On </StyledSubTableCell>
                {/* 
                      <StyledSubTableCell>
                      Supplier Name
                      </StyledSubTableCell>
                      <StyledSubTableCell>Parameters</StyledSubTableCell>
                      <StyledSubTableCell>Limits </StyledSubTableCell>
                      <StyledSubTableCell>Test Results</StyledSubTableCell> */}
                <StyledSubTableCell>Notes</StyledSubTableCell>

                {/* <StyledSubTableCell padding="checkbox"></StyledSubTableCell> */}
              </TableRow>

            </TableHead>
            <TableBody>
            {formObj.history.length
                    ? formObj.history.map((row) => (
                        <HistoryRow key={row.ticketId}  row={row}  />
                      ))
                    : ""}
            </TableBody>
          </Table>
        </Box>
        <TableCell style={{ padding: 0 }} colSpan={6}>

          <Box mb={2}>

          </Box>
        </TableCell>
      </div>
    </div>
  )
}


export default Support

